import React from 'react'

const ThreeDots = () => {
    return (
        <svg width="26" height="6" viewBox="0 0 26 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" transform="matrix(1 0 0 -1 10 6)" fill="#888888" />
            <circle cx="3" cy="3" r="3" transform="matrix(1 0 0 -1 20 6)" fill="#888888" />
            <circle cx="3" cy="3" r="3" transform="matrix(1 0 0 -1 0 6)" fill="#888888" />
        </svg>

    )
}

export default ThreeDots